import Dme from '@presentation/assets/navaid/dme.png'
import DmeActive from '@presentation/assets/navaid/dme-active.png'
import Ndb from '@presentation/assets/navaid/ndb.png'
import NdbActive from '@presentation/assets/navaid/ndb-active.png'
import Vor from '@presentation/assets/navaid/vor.png'
import VorActive from '@presentation/assets/navaid/vor-active.png'
import VorDme from '@presentation/assets/navaid/vor-dme.png'
import VorDmeActive from '@presentation/assets/navaid/vor-dme-active.png'

export const navaidIcons = {
  vor: Vor,
  'vor-active': VorActive,
  ndb: Ndb,
  'ndb-active': NdbActive,
  'vor-dme': VorDme,
  'vor-dme-active': VorDmeActive,
  dme: Dme,
  'dme-active': DmeActive
} as const

export type NavaidIconId = keyof typeof navaidIcons
